import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { Pair } from '../../../interfaces/pair';
import { Donor } from '../../../interfaces/donor';
import { Recipient } from '../../../interfaces/recipient';
import { MatButtonModule } from '@angular/material/button';
import { PairService } from '../../../services/pair.service';
import { ParticipantService } from '../../../services/participant.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  imports: [CommonModule, MatDialogContent, MatDialogActions, MatButtonModule],
  templateUrl: './confirm-dialog.component.html',
  providers: [NotifyService],
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  pair?: Pair;
  donor?: Donor;
  recipient?: Recipient;

  constructor(
    private pairService: PairService,
    private participantService: ParticipantService,
    private readonly notify: NotifyService,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pair?: Pair; donor?: Donor; recipient?: Recipient; message?: string }
  ) {
    this.pair = data.pair;
    this.donor = data.donor;
    this.recipient = data.recipient;
    console.log(data);
  }

  close(): void {
    this.dialogRef.close();
  }

  async toggleConfirm(): Promise<void> {
    if (this.data.pair) {
      // Handle pair activation
      this.data.pair.active = !this.data.pair.active;
      this.pairService.updatePair(this.data.pair).subscribe({
        next: (updatedPair) => {
          console.log('Pair updated:', updatedPair);
          this.notify.withAutodismiss(`Set pair to: ${updatedPair.active ? 'active' : 'inactive'}`);
          this.dialogRef.close(updatedPair); // Return the updated pair from backend
        },
        error: (err) => {
          console.log(err);
          this.notify.withAutodismiss(`Failed to set pair to: ${this.data.pair!.active ? 'active' : 'inactive'}`);
          this.dialogRef.close(null); // Close dialog with error handling
        }
      });
    } else if (this.data.donor) {
      // Handle donor activation
      const updatedDonor = { ...this.data.donor, active: true, reasonInactive: undefined };
      this.participantService.updateDonor(updatedDonor).subscribe({
        next: (result) => {
          console.log('Donor updated:', result);
          this.notify.withAutodismiss('Donor set to active');
          this.dialogRef.close(result); // Return the updated donor from backend
        },
        error: (err) => {
          console.log(err);
          this.notify.withAutodismiss('Failed to activate donor');
          this.dialogRef.close(null);
        }
      });
    } else if (this.data.recipient) {
      // Handle recipient activation
      const updatedRecipient = { ...this.data.recipient, active: true, reasonInactive: undefined };
      this.participantService.updateRecipient(updatedRecipient).subscribe({
        next: (result) => {
          console.log('Recipient updated:', result);
          this.notify.withAutodismiss('Recipient set to active');
          this.dialogRef.close(result); // Return the updated recipient from backend
        },
        error: (err) => {
          console.log(err);
          this.notify.withAutodismiss('Failed to activate recipient');
          this.dialogRef.close(null);
        }
      });
    } else {
      // Simple confirmation dialog with only a message - just return true
      this.dialogRef.close(true);
    }
  }
}
